import { TOGGLE_SIDE_NAV, TOGGLE_ACCORDION } from './actions';

const initialStateHeader = {
  isSideNav: true,
  accordions: {},
};

//needs to persist across pages
export const headerReducer = (state = initialStateHeader, action) => {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_SIDE_NAV: {
      return { ...state, isSideNav: !state.isSideNav };
    }
    case TOGGLE_ACCORDION: {
      const accordions = state.accordions || {};
      const current = accordions[payload.key] ?? true;
      return {
        ...state,
        accordions: { ...accordions, [payload.key]: !current },
      };
    }
    default:
      return state;
  }
};
